﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g
    fill="none"
    fill-rule="evenodd"
    stroke-linecap="round"
    stroke-linejoin="round">
    <g transform="translate(1.000000, 1.000000)">
      <polyline id="Path" points="18 6.999 11 16.499 6 12.499" />
      <path
        d="M0.5,11.9989998 C0.5,16.1075543 2.69188754,19.9040151
        6.24999995,21.9582923 C9.80811236,24.0125695 14.1918876,24.0125695
        17.75,21.9582923 C21.3081125,19.9040151 23.5,16.1075543 23.5,11.9989998
        C23.5,7.89044568 21.3081125,4.09398489 17.75,2.03970771
        C14.1918876,-0.0145694664 9.80811236,-0.0145694664 6.24999995,2.03970771
        C2.69188754,4.09398489 0.5,7.89044568 0.5,11.9989998 L0.5,11.9989998 Z"
        id="Path" />
    </g>
  </g>
</svg>
